import React, { Component } from 'react';
import { Typography, IconButton, Button, LinearProgress } from '@material-ui/core';
import { KeyboardBackspaceOutlined } from '@material-ui/icons';
import AutoCompletar from '../utils/AutoCompletar';
import appStore from '../../stores/AppStore';
import ViewConstants from '../../utils/ViewConstants';
import { observer } from 'mobx-react';
import '../../styles/Globales.scss';
import '../../styles/SolicitarPortabilidad.scss';
import * as ProductosConstants from '../../utils/ProductosConstants';
import NuevoCompromisoDeudaComponent from './NuevoCompromisoDeudaComponent';
import PreguntaPortarTodosComponent from './PreguntaPortarTodosComponent';

const PREGUNTA = 1;
const COMPROMISO = 2;
const SI = 'SI';
const NO = 'NO';
const NO_ESPECIFICADO = 'N/A';
export default observer(
  class SeleccionBancoComponent extends Component {
    constructor(props) {
      super(props);
      let codigoSeleccionado;
      if (appStore.solicitarNuevaPortalidadStore.bancoSeleccionado) {
        codigoSeleccionado = appStore.solicitarNuevaPortalidadStore.bancoSeleccionado.id;
      }
      let migrarTodos = NO_ESPECIFICADO;
      if (appStore.solicitarNuevaPortalidadStore.bolsaProductos.length > 0) {
        if (appStore.solicitarNuevaPortalidadStore.familiaSeleccionada(ProductosConstants.TODOS_LOS_PRODUCTOS)) {
          migrarTodos = SI;
        } else {
          migrarTodos = NO;
        }
      }
      this.state = {
        codigoBancoSeleccionado: codigoSeleccionado,
        cmbBancos: [],
        migrarTodos: migrarTodos,
        etapa: PREGUNTA,
      };
    }

    componentDidMount = () => {
      appStore.solicitarNuevaPortalidadStore.cargarBancos(this.onBancosCargados);
      appStore.solicitarNuevaPortalidadStore.cargarFamiliasProductos();
      appStore.solicitarNuevaPortalidadStore.cargarProductos();
    };

    onBancosCargados = () => {
      this.setState({
        cmbBancos: appStore.solicitarNuevaPortalidadStore.cmbBancos,
      });
    };

    onSelectionChanged = (nombreCombo, value) => {
      if (value !== this.state.codigoBancoSeleccionado) {
        appStore.solicitarNuevaPortalidadStore.limpiarBolsa();
        appStore.solicitarNuevaPortalidadStore.productosContratar = {};
      }
      this.setState({ codigoBancoSeleccionado: value, etapa: PREGUNTA });
    };

    onSeleccionBancoComplete = () => {
      const bancoSeleccionado = this.findBancoByValue(this.state.codigoBancoSeleccionado);
      if (bancoSeleccionado) {
        appStore.solicitarNuevaPortalidadStore.seleccionarBanco({ id: bancoSeleccionado.value, nombre: bancoSeleccionado.label });
      }
      if (this.state.migrarTodos === SI) {
        appStore.generateDataLayer({ eventAction: 'step_3.1', eventLabel: 'todos_institucion_continuar' });
        this.setState({ etapa: COMPROMISO });
      } else {
        appStore.generateDataLayer({ eventAction: 'step_3.1', eventLabel: 'algunos_institucion_continuar' });
        appStore.solicitarNuevaPortalidadStore.compromisoDeuda = {};
        appStore.changeNavigation(ViewConstants.ETAPA_NUEVA_PORTABILIDAD);
      }
    };

    findBancoByValue = (value) => {
      let result;
      if (this.state.cmbBancos) {
        result = this.state.cmbBancos.find((item) => {
          return item.value === value;
        });
      }
      return result;
    };

    onVolver = () => {
      if (this.state.etapa === PREGUNTA) {
        if (appStore.solicitudesCliente && appStore.solicitudesCliente.length > 0) {
          appStore.cargarSolicitudesCliente(() => {
            appStore.changeNavigation(ViewConstants.ETAPA_LISTADO_SOLICITUDES);
          });
        } else {
          appStore.changeNavigation(ViewConstants.ETAPA_PREGUNTASSEGURIDAD);
        }
      } else {
        this.setState({ etapa: PREGUNTA });
      }
    };

    onChangeMigrarTodos = (portarTodos) => {
      if (portarTodos === NO) {
        appStore.solicitarNuevaPortalidadStore.eliminarFamilia(ProductosConstants.TODOS_LOS_PRODUCTOS);
        appStore.generateDataLayer({ eventAction: 'step_3', eventLabel: 'algunos_institucion_producto' });
      } else {
        appStore.generateDataLayer({ eventAction: 'step_3', eventLabel: 'todos_institucion_producto' });
      }
      this.setState({ migrarTodos: portarTodos });
    };

    conCompromisoDeuda = (tarjetas, lineas) => {
      const producto = {
        codProducto: ProductosConstants.TODOS_LOS_PRODUCTOS,
        nombreProducto: 'Todos mis Productos',
        compromisoDeuda: {
          lineas: lineas,
          tarjetas: tarjetas
        }
      };
      appStore.generateDataLayer({ eventAction: 'step_4', eventLabel: 'todos_compromiso_continuar' });
      appStore.solicitarNuevaPortalidadStore.agregarProducto(producto);
      appStore.changeNavigation(ViewConstants.ETAPA_PRODUCTOS_A_CONTRATAR);
    };

    renderCompromisoDeuda = () => {
      return <NuevoCompromisoDeudaComponent onContinuar={this.conCompromisoDeuda} onVolver={() => this.setState({ etapa: PREGUNTA })} tipoProducto={ProductosConstants.TODOS_LOS_PRODUCTOS} />;
    };

    preguntaPortarTodos = () => {
      const bancoSeleccionado = this.findBancoByValue(this.state.codigoBancoSeleccionado);
      let nombreBanco;
      let pregunta;
      if (bancoSeleccionado) {
        nombreBanco = bancoSeleccionado.label;
        pregunta = <PreguntaPortarTodosComponent portarTodos={this.state.migrarTodos} nombreBanco={nombreBanco} onSeleccionChange={this.onChangeMigrarTodos} />;
      }
      return (
        <div className="bloqueSeleccionBanco">
          <Typography className="tituloStepSolicitud">Selecciona la institución financiera desde la que deseas portar tus productos:</Typography>
          <Typography className="tituloAutocompletar">Institución financiera</Typography>
          <div className="autoCompletar">
            <AutoCompletar
              className="TextRipley"
              id="txtFiltroBancos"
              fullWidth={true}
              valor={this.state.codigoBancoSeleccionado}
              handleChange={this.onSelectionChanged}
              options={this.state.cmbBancos}
              showLabel={true}
              label="Institución financiera"
              placeholder="Busca aqui tu institución"
              isClearable={false}
            ></AutoCompletar>
          </div>
          <div className="bloqueSeleccionBanco">{pregunta}</div>
          <div className="botones">
            <Button color="primary" id="btnContinuar" className="btnRipley" fullWidth={true} onClick={this.onSeleccionBancoComplete} disabled={this.state.migrarTodos === NO_ESPECIFICADO}>
              Continuar{' '}
            </Button>
          </div>
        </div>
      );
    };

    render = () => {
      let contenido;
      let titulo;
      if (this.state.etapa === PREGUNTA) {
        contenido = this.preguntaPortarTodos();
        titulo = 'Selección institución financiera';
      } else if (this.state.etapa === COMPROMISO) {
        contenido = this.renderCompromisoDeuda();
        titulo = 'Compromiso no aumentar deuda';
      }
      return (
        <div className="contenedorPrincipal">
          <div className="paso">
            <Typography className="tituloBR">
              <IconButton onClick={this.onVolver}>
                <KeyboardBackspaceOutlined />
              </IconButton>
              {titulo}
            </Typography>
          </div>
          <LinearProgress variant="determinate" color="secondary" value={appStore.navigationSection * (100 / ViewConstants.TOTAL_ETAPAS)} className="barraProgreso" />
          <div className="bloqueSeleccionBanco">{contenido}</div>
        </div>
      );
    };
  }
);
